import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=1e5b2835"
import script from "./NotificationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports